<template>
	<layout v-bind="{disabled}">
		<datepicker
			v-bind="{
				value: val,
				format,
				disabled,
				disabledDates,
				mondayFirst: true,
				placeholder: '...',
				inputClass: 'input',
			}"
			@selected="update"
		/>
	</layout>
</template>

<script>
import {getDay, eachDay, addDays, isSameDay} from "date-fns";
import datepicker from "vuejs-datepicker";
import layout from "./layout/input.vue";
import {date} from "@/modules/utils";

export default {
	components: {datepicker, layout},
	props: {
		value: {type: String, required: false},
		disabled: {type: Boolean, required: false}
	},
	data() {
		return {
			format: "dd.MM.yyyy",
			val: this.value ? new Date(this.value.split(".").reverse().join("-")) : null,
			disabledDays: [5,6,0], // friday, saturday, sunday
			skippedDays: 8
		}
	},
	computed: {
		disabledDates: (t) => ({
			days: t.disabledDays,
			to: t.disabledTo
		}),

		disabledTo() {
			const today = new Date();

			// get array of possible dates
			let range = eachDay(today, new Date(addDays(today, 20)));

			// remove disabledDays
			range = range.filter(x => !this.disabledDays.includes(getDay(x)));

			// if range starts on today, remove it
			range = range.filter(x => !isSameDay(x, today));

			// skip number of days ahead
			range = range.slice(this.skippedDays - 1);

			// return first day
			return range[0];
		}
	},
	methods: {
		update(value) {
			const d = date(value / 1000);
			value = `${d.day}.${d.month}.${d.year}`;
			this.$emit("update", value);
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
